<template>
  <div class="powerDevice" style="height: 100%;color: #FAFAFA;">
    <label style="padding: 20px 0 10px 30px;color: #01effd;" v-if="label">
      <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
      配电柜电表</label>
    <!--电表-->
    <el-row v-if="demDeviceList.length>0" style="height: 100%">
      <el-carousel :interval="10000" indicator-position="none" :autoplay="true" style="height: 100%;z-index: 0"
                   @change="getDemData">
        <el-carousel-item :key="item.id" v-for="item in demDeviceList">
          <el-row>
            <el-row class="text-center">
              <label :class="label ?'pointer' : ''"
                     @touchstart="skipOverview(item)"
                     @click="skipOverview(item)"
                     style="line-height: 3vh;">{{ item.spaceName }} -
                {{ item.name }}</label>
            </el-row>
            <span
              v-if="meterData != null && meterData.deviceInfoList[0] != null && meterData.deviceInfoList[0].deviceMeasuringPointHistoryList.length> 0">
                  <el-row style="margin-top: 10px;">
                    <span :key="history.id"
                          v-for="history in meterData.deviceInfoList[0].deviceMeasuringPointHistoryList">
                      <el-col :span="9" style="margin:2% 0 0 5%">
                        <div style="width: 40%;display: inline-block;text-align: right">
                          <img src="../../assets/images/index/activePower.png" alt="" style="width: 100%;">
                        </div>
                        <div class="point" style="text-align:center;float: right;width: 60%;">
                          <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                          <div class="text-blueGrey">{{ history.pointName }}</div>
                        </div>
                      </el-col>
                    </span>
                </el-row>
                </span>
            <div v-else>
              <no-data></no-data>
            </div>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <div v-else style="height: 50%;padding-top: 5%">
      <no-data></no-data>
    </div>
  </div>
</template>
<script>
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import {getDeviceByTypeList} from "@/network/device-info";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "CabinetElectricity",
  mixins: [platenLayoutEdit],
  components: {NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    meterHeight: {
      default: '14vh',
    },
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId: {
      handler() {
        this.upsData = null;
        this.meterData = null;
        this.getData();
        this.getDeviceList();
      }
    }
  },
  data() {
    return {
      data: [],
      typeList: ["PM_DEM"],
      pointCodes: ["av1", "bv2", "cv3", "ai1", "bi2", "ci3", "pf"],
      upsData: null,
      meterData: null,
      upsDeviceList: [],
      demDeviceList: []
    }
  },
  mounted() {
    this.getDeviceList();
  },
  methods: {
    getDeviceList() {
      this.demDeviceList = []
      getDeviceByTypeList(this.typeList, this.spaceId).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_DEM') {
              this.demDeviceList.push(item)
            }
          })
          if (this.demDeviceList.length > 0) {
            this.getDemData(0)
          }
        }
      })
    },
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_DEM') {
              this.meterData = item;
            }
          })
        }
      })
    },
    getDemData(active) {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        deviceId: this.demDeviceList[active].id,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            this.meterData = item;
          })
        }
      })
    },
    skipOverview(deviceInfo) {
      if (this.isPlatenLayoutEditing) return
      this.$emit('skipOverview', deviceInfo, 'power_category_tag')
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
}

.powerDevice .el-progress >>> .el-progress-bar__outer {
  background-color: rgba(48, 141, 233, .3);
}

.powerDevice .el-progress >>> .el-progress-bar__inner {
  background: linear-gradient(to right, rgba(224, 201, 85, 1), rgba(208, 103, 102, 1));
}

.powerDevice .el-progress >>> .el-progress__text {
  margin-left: 20px;
  color: #FAFAFA;
}
</style>
